import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import center from "./images/center.png";
import left from "./images/left.png";
import right from "./images/right.png";
import * as styles from "./styles.module.scss";

const Tile = ({ text, isActive, isSmall }) => (
  <div
    className={classNames(styles.container, {
      [styles.isActive]: isActive,
      [styles.isSmall]: isSmall,
    })}
    data-test-type="Tile"
  >
    <div className={styles.background}>
      <div className={styles.center}>
        <img src={center} />
      </div>
      <div className={styles.left}>
        <img src={left} />
      </div>
      <div className={styles.right}>
        <img src={right} />
      </div>
    </div>
    <div className={styles.textContainer}>{text}</div>
  </div>
);

Tile.propTypes = {
  text: PropTypes.string,
  isActive: PropTypes.bool,
  isSmall: PropTypes.bool,
};

export default Tile;
